import {connect} from 'react-redux';
import SmartplayerVideo from '../SmartplayerVideo';
import Action from '../../../redux/Actions';
import TimeFormatter from '../../../utils/TimeFormatter/TimeFormatter';
import MediaDimensionsModel from '../../../types/MediaDimensionsModel';
import IVideoPlayer from '../../../types/IVideoPlayer';
import ReduxState from '../../../types/ReduxState';
import {Dispatch} from 'redux';
import {AnnotationModes, QuizState} from '../../../globals/Constants';
import Config from '../../../globals/Config';

const mapStateToProps = (state: ReduxState, ownProps: VideoContainerProps) => {
   return {
      src: state.currentReviewVersion.MediaUrl,
      themeName: state.themeName,
      mediaDimensions: state.mediaDimensions || null,
      annotationMode: ownProps.annotationMode,
      mobileViewingMode: state.mobileViewingMode,
      storeAnnotation: ownProps.storeAnnotation,
      posterSrc: state.currentReviewVersion.ThumbnailUrl,
      srcMediaDimensions: {
         width: state.currentReviewVersion.MediaWidth,
         height: state.currentReviewVersion.MediaHeight
      },
      xmpSrc: state.currentReviewVersion.XmpId ? `${Config.apiEndPoint}${Config.apiPrefix}/xmp/${state.currentReviewVersion.XmpId}` : '',
      audioDescriptionMediaSrc: state.currentReviewVersion.AudioDescriptionUrl,
      quizId: Config.quizId,
      accessTokenEndpoint: Config.webConnector.common.oauthTokenEndpoint,
      currentUser: state.currentUser,
      environment: Config.environment
   };
};

const lastUpdate: any = {};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>) => {
   return {
      setPlayer: (player: IVideoPlayer) => {
         const updatePlayerTime = () => {
            const currentTime = TimeFormatter.getRoundedTime(player.getCurrentTime());
            const compensatedTime = Math.min(lastUpdate.duration, currentTime); // Compensating for Microsoft video timing
            if (compensatedTime !== lastUpdate.currentTime) {
               lastUpdate.currentTime = compensatedTime;
               dispatch(Action.setPlayerProgress(compensatedTime));
            }
         };

         player.on('timeupdate', updatePlayerTime);

         const setDuration = () => {
            const duration = TimeFormatter.getRoundedTime(player.getDuration());
            lastUpdate.duration = duration;
            dispatch(Action.setVideoDuration(duration));
            dispatch(Action.setPlayer(player));
         };

         if (player.getDuration()) {
            setDuration();
         } else {
            player.on('loadedmetadata', setDuration);
         }
      },
      setMediaDimensions: (mediaDimensions: MediaDimensionsModel) => {
         dispatch(Action.setMediaDimensions(mediaDimensions));
      },
      setQuizState: (quizState: QuizState) => {
         dispatch(Action.setQuizState(quizState));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(SmartplayerVideo);

interface VideoContainerProps {
   annotationMode: AnnotationModes;
   storeAnnotation(annotation: string): void;
}